import { ConfirmModal } from "../../../../common/modals/PopupModals";

const ConfirmAbandonEditsModal = ({
  shouldShow,
  hideModal,
  confirmAction,
}) => (
  <ConfirmModal
    shouldShow={shouldShow}
    hideModal={hideModal}
    title="Abandon Edits"
    confirmText="Confirm"
    cancelText="Cancel"
    confirmAction={confirmAction}
    cancelAction={hideModal}
  >
    <p>
      Are you sure you want to go back?{" "}
      <b>You will lose any unsaved changes.</b>
    </p>
    <p>Are you sure you want to proceed?</p>
  </ConfirmModal>
);

export default ConfirmAbandonEditsModal;
